module.exports = __webpack_public_path__ + "videos/animation.93aa239.mp4";